var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5003 49.3035C14.5909 49.3035 4.91699 39.4147 4.91699 27.1905C4.91699 14.9663 14.5909 5.07764 26.5003 5.07764C38.4097 5.07764 48.0837 14.9663 48.0837 27.1905C48.0837 39.4147 38.4097 49.3035 26.5003 49.3035ZM26.5003 45.7809C31.3223 45.7809 35.9443 43.8193 39.3503 40.3317C42.7558 36.8445 44.667 32.1172 44.667 27.1905C44.667 22.2639 42.7558 17.5366 39.3503 14.0494C35.9443 10.5618 31.3223 8.60022 26.5003 8.60022C21.6784 8.60022 17.0563 10.5618 13.6504 14.0494C10.2448 17.5366 8.33366 22.2639 8.33366 27.1905C8.33366 32.1172 10.2448 36.8445 13.6504 40.3317C17.0563 43.8193 21.6784 45.7809 26.5003 45.7809ZM28.2087 35.9744V36.497C28.2087 37.3254 27.5371 37.997 26.7087 37.997H26.292C25.4636 37.997 24.792 37.3254 24.792 36.497V35.9744C24.792 35.146 25.4636 34.4744 26.292 34.4744H26.7087C27.5371 34.4744 28.2087 35.146 28.2087 35.9744ZM28.2087 17.8841V27.4518C28.2087 28.2803 27.5371 28.9518 26.7087 28.9518H26.292C25.4636 28.9518 24.792 28.2803 24.792 27.4518V17.8841C24.792 17.0557 25.4636 16.3841 26.292 16.3841H26.7087C27.5371 16.3841 28.2087 17.0557 28.2087 17.8841Z",
    fill: "#AB79F8",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning2.1ac59f20ea834b7e2cc44218041cf682.svg";
export { ForwardRef as ReactComponent };